/**
 * Created by Viacheslav Stepanian on 11.06.2026
 */

cleverapps.overrideColors(cleverapps.styles.COLORS, {
    SPACE_RACE_TITLE_STROKE: new cc.Color(129, 0, 203, 255),
    SPACE_RACE_DESCRIPTION_STROKE: new cc.Color(33, 50, 173, 255),
    SPACE_RACE_STAGE_COLOR: new cc.Color(252, 255, 103, 255),
    SPACE_RACE_STAGE_STROKE: new cc.Color(127, 0, 200, 255)
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    SPACE_RACE_SCORE_TEXT: {
        name: "nostroke",
        size: 30,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_2PX
    },
    SPACE_RACE_WINDOW_MAIN_TITLE_TEXT: {
        size: 55,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.SPACE_RACE_TITLE_STROKE
    },
    SPACE_RACE_WINDOW_LOCATION_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },
    SPACE_RACE_WINDOW_DESCRIPTION_TEXT: {
        size: 35,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.SPACE_RACE_DESCRIPTION_STROKE
    },
    SPACE_RACE_WINDOW_TIMER_TEXT: {
        name: "nostroke",
        size: 55,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },
    SPACE_RACE_VERTICAL_TIMER_TEXT: {
        name: "nostroke",
        size: 50,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },
    SPACE_RACE_STAGE_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.SPACE_RACE_STAGE_COLOR,
        stroke: cleverapps.styles.DECORATORS.SPACE_RACE_STAGE_STROKE
    },
    SPACE_RACE_STAGE_NUM_TEXT: {
        size: 70,
        color: cleverapps.styles.COLORS.SPACE_RACE_STAGE_COLOR,
        stroke: cleverapps.styles.DECORATORS.SPACE_RACE_STAGE_STROKE
    },
    SPACE_RACE_START_WINDOW_TEXT: {
        size: 35,
        name: "nostroke",
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },
    SPACE_RACE_PLACE_TEXT: {
        size: 45,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_2PX
    },
    SPACE_RACE_WINDOW_RIBBON_CLAIM_TEXT: {
        name: "lightstroke",
        size: 40,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_2PX
    }
});
